import React from 'react';
import { Helmet } from 'react-helmet';

const Schema = ({ type, data }) => {
  let schemaData = null;

  if (type === 'organization') {
    schemaData = {
      "@context": "https://schema.org",
      "@type": "Organization",
      "name": "Pulpit Cabs",
      "alternateName": "Pulpit Mobility",
      "url": "https://pulpitcabs.com",
      "logo": "https://pulpitcabs.com/logo512.png",
      "description":
        "One-way and round-trip outstation cab booking across 450+ Indian cities with transparent per-kilometre fares and verified drivers.",
      // Only profiles verified to exist. The previous list used a guessed
      // /pulpitcabs handle on every network - two were dead links, and none
      // matched the real profiles the footer links to, so the entity signal
      // pointed away from the actual accounts.
      "sameAs": [
        "https://www.facebook.com/PulpitMobility/",
        "https://www.instagram.com/pulpit_cabs/",
        "https://x.com/mobilitypulpit",
        "https://www.linkedin.com/company/pulpit-mobility"
      ],
      "address": {
        "@type": "PostalAddress",
        "streetAddress": "305, Capitol Icon, Sargasan",
        "addressLocality": "Gandhinagar",
        "addressRegion": "Gujarat",
        "postalCode": "382421",
        "addressCountry": "IN"
      },
      "contactPoint": {
        "@type": "ContactPoint",
        "telephone": "+91-8052080501",
        "email": "info@pulpitcabs.com",
        "contactType": "customer service",
        "areaServed": "IN",
        "availableLanguage": ["en", "hi"]
      }
    };
  }

  if (type === 'service' && data) {
    schemaData = {
      "@context": "https://schema.org",
      "@type": "TaxiService",
      "name": data.name || "Cab Service",
      "description": `Reliable and affordable cab service in ${data.city || 'your city'}. Book local or outstation rides.`,
      "provider": {
        "@type": "LocalBusiness",
        "name": "Pulpit Cabs",
        "image": "https://pulpitcabs.com/logo512.png",
        "url": "https://pulpitcabs.com",
        "telephone": "+91-8052080501",
        "priceRange": "₹"
      },
      "areaServed": {
        "@type": "City",
        "name": data.city || "Ahmedabad"
      },
      // No aggregateRating here on purpose. The old markup hardcoded 4.8/1200
      // with no reviews rendered anywhere on the page - review markup that
      // does not reflect on-page reviews is against Google's structured-data
      // policy and a manual-action risk. Re-add only when real, visible
      // reviews back the numbers.
      "hasOfferCatalog": {
        "@type": "OfferCatalog",
        "name": "Cab Services",
        "itemListElement": [
          {
            "@type": "Offer",
            "itemOffered": {
              "@type": "Service",
              "name": "Outstation Cab"
            }
          },
          {
            "@type": "Offer",
            "itemOffered": {
              "@type": "Service",
              "name": "Local Rental"
            }
          }
        ]
      }
    };
  }

  if (type === 'route' && data) {
    schemaData = {
      "@context": "https://schema.org",
      "@type": "Service",
      "name": `Cab from ${data.from} to ${data.to}`,
      "description": `Intercity cab service between ${data.from} and ${data.to}. Distance: ${data.distance}km.`,
      "provider": {
        "@type": "LocalBusiness",
        "name": "Pulpit Cabs",
        "image": "https://pulpitcabs.com/logo512.png",
        "url": "https://pulpitcabs.com",
        "telephone": "+91-8052080501",
        "priceRange": `₹${data.price}`
      },
      "offers": {
        "@type": "Offer",
        "price": data.price,
        "priceCurrency": "INR",
        "url": `https://pulpitcabs.com/routes/${data.from.toLowerCase()}-to-${data.to.toLowerCase()}-cab/`
      },
      "itinerary": {
        "@type": "City",
        "name": data.from,
        "subTrip": {
          "@type": "City",
          "name": data.to
        }
      }
    };
  }

  if (!schemaData) return null;

  return (
    <Helmet defer={false}>
      <script type="application/ld+json">
        {JSON.stringify(schemaData)}
      </script>
    </Helmet>
  );
};

export default Schema;
